// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field-form .field-form__name .c-input-floating-label {\n  min-width: 142px!important;\n}\n", ""]);
// Exports
module.exports = exports;
